import { i18nManager } from '@/utils/i18n';

export default {
  data() {
    return {
      // 用于强制更新组件的key
      i18nUpdateKey: 0
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage || i18nManager.getCurrentLanguage() || 'zh-TW';
    }
  },
  methods: {
    // 多语言文本获取器
    $t(category, key) {
      return i18nManager.getText(category, key, this.currentLanguage);
    },
    // 切换语言
    switchLanguage(language) {
      // 提交到Vuex
      this.$store.commit('SET_LANGUAGE', language);
      // 更新i18nManager
      i18nManager.setLanguage(language);
      // 强制更新当前组件
      this.forceUpdate();
      // 强制更新所有子组件
      this.forceUpdateAllChildren();
      // 更新Element UI的locale
      this.$updateElementUILocale(language);
      // 更新浏览器标题
      this.updateBrowserTitle(language);
      // 触发全局事件 - 保持兼容性
      this.$root.$emit('language-changed', language);
    },
    // 获取文本
    getText(category, key) {
      return i18nManager.getText(category, key);
    },
    // 强制更新当前组件
    forceUpdate() {
      this.i18nUpdateKey += 1;
    },
    // 递归强制更新所有子组件
    forceUpdateAllChildren() {
      const updateChild = (component) => {
        if (component && typeof component.forceUpdate === 'function') {
          component.forceUpdate();
        }
        if (component.$children && component.$children.length > 0) {
          component.$children.forEach(updateChild);
        }
      };
      updateChild(this);
    },
    
    // 更新浏览器标题
    updateBrowserTitle(language) {
      const currentRoute = this.$route;
      if (currentRoute && currentRoute.meta && currentRoute.meta.title) {
        const title = currentRoute.meta.title;
        if (typeof title === 'object' && title !== null) {
          document.title = title[language] || title['zh-TW'] || '睿哲智能crm';
        }
      }
    }
  },
  mounted() {
    // 监听语言变化事件
    this.$root.$on('language-changed', (language) => {
      this.forceUpdate();
      this.forceUpdateAllChildren();
    });
    
    // 监听Element UI locale更新事件
    this.$root.$on('element-ui-locale-updated', () => {
      this.forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    this.$root.$off('language-changed');
    this.$root.$off('element-ui-locale-updated');
  }
};
